declare global {
  const __COMMIT_HASH__: string;
  const __BUILD_TAG__: string;
}

export enum API_TAGS {
  AIFilters = 'AIFilters',
  Workspaces = 'Workspaces',
  WorkspaceTypes = 'WorkspaceTypes',
  WorkspaceContext = 'WorkspaceContext',
  FilterConfigs = 'FilterConfigs',
  Filters = 'Filters',
  Advertisers = 'Advertisers',
  PermissionData = 'PermissionData',
  Schedules = 'Schedules',
  SingleWorkspace = 'SingleWorkspace',
  SaveWorkspace = 'SaveWorkspace',
  Releases = 'Releases',
  ExpansionMetaData = 'ExpansionMetaData',
}
